import { render, staticRenderFns } from "./Logistics_detail.vue?vue&type=template&id=7ef94ff6&scoped=true"
import script from "./Logistics_detail.vue?vue&type=script&lang=js"
export * from "./Logistics_detail.vue?vue&type=script&lang=js"
import style0 from "./Logistics_detail.vue?vue&type=style&index=0&id=7ef94ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef94ff6",
  null
  
)

export default component.exports